import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { environment } from '../../../environments/environment';


@Injectable({
    providedIn: 'root'
})
export class ShowProductosSimpleGuardService {

    constructor(public router: Router) {}

    canActivate(): boolean | UrlTree{

        if (!environment.features.showProductosSimple) {
            this.router.parseUrl('/login');
            return false;
        }

        return true;
    }
}
